import { Snackbar, Alert, AlertTitle, Typography } from '@mui/material';

import { ReactComponent as Celebration } from 'common/assets/images/celebration.svg';
import { FEEDBACK_FORM_LABEL } from 'common/constants/AskRiskLinkConstants';

import styles from './RiskGptFeedBackSuccessAlert.module.scss';

interface Props {
	open: boolean;
	vertical: 'top' | 'bottom';
	horizontal: 'right' | 'left' | 'center';
	handleCloseMessage: () => void;
}

const { FEEDBACK_SUCCESS_ALERT_TITLE, FEEDBACK_SUCCESS_ALERT_SUB_TITLE } =
	FEEDBACK_FORM_LABEL;
const RiskGptFeedBackSuccessAlert = (props: Props) => {
	const { open, vertical, horizontal, handleCloseMessage } = props;

	return (
		<div data-testid="alert-component">
			{' '}
			<Snackbar
				className={styles['snackbar-parent-background']}
				open={open}
				autoHideDuration={5000}
				onClose={handleCloseMessage}
				key={vertical + horizontal}
				anchorOrigin={{ vertical, horizontal }}
			>
				<Alert
					className={styles['snackbar-background']}
					onClose={handleCloseMessage}
					icon={<Celebration />}
				>
					<AlertTitle className={styles['alert-title']}>
						{FEEDBACK_SUCCESS_ALERT_TITLE}
					</AlertTitle>
					{open ? (
						<Typography className={styles['alert-sub-header']}>
							{FEEDBACK_SUCCESS_ALERT_SUB_TITLE}
						</Typography>
					) : null}
				</Alert>
			</Snackbar>
		</div>
	);
};

export default RiskGptFeedBackSuccessAlert;
